/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from '@dtsl/css-togglelink/dist/index.module.css';
import ChevronUp from '@dtsl/icons/dist/icons/react/ChevronUp';
import { onCollapsable } from '@dtsl/react/dist/components/Utils/collapsible';
import '@dtsl/css-dropdown/dist/collapsible.css';
function Togglelink(props) {
  const {
    heading = 'Default',
    children,
    disabled = false,
    defaultOpen = false,
    className = ''
  } = props;
  const toggleLinkClasses = classNames({
    [`sib-collapsible ${styles['sib-togglelink']}`]: true,
    [styles['disabled']]: disabled,
    [className]: !!className
  });

  // console.log('dropdownStyles: ', dropdownStyles);
  // console.log('styles: ', styles);

  const triggerClasses = classNames({
    [styles['sib-togglelink-header']]: true,
    'sib-collapsible__trigger': true,
    'sib-collapsible__trigger_toggled': defaultOpen
  });
  const contentClasses = classNames({
    [styles['sib-togglelink-content']]: true,
    'sib-collapsible__content': true,
    'sib-collapsible__content_toggled': defaultOpen
  });
  return /*#__PURE__*/React.createElement("div", {
    className: toggleLinkClasses
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    tabIndex: "0",
    disabled: disabled,
    onClick: onCollapsable,
    className: triggerClasses
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['sib-togglelink-header-content']
  }, /*#__PURE__*/React.createElement("span", {
    className: styles['sib-togglelink-title']
  }, heading), /*#__PURE__*/React.createElement(ChevronUp, {
    className: "sib-dropdown-option-group-marker"
  }))), /*#__PURE__*/React.createElement("div", {
    className: contentClasses,
    "data-collapsible-behavior": "shutter",
    "data-speed-divisor": "2"
  }, children));
}
Togglelink.propTypes = {
  heading: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  defaultOpen: PropTypes.bool,
  className: PropTypes.string
};
export default Togglelink;